import Link from 'next/link'

import PageBuilder from '../PageBuilder'
import PageHeader from './PageHeader'

interface PageProps {
	page: any
	dynamicData?: any
}

const Page = (props: PageProps) => {

	const { page, dynamicData } = props

	// console.log('SubPage page: ', page)

	return (
		<>
			<PageHeader page={page} />
			<PageBuilder contentBlocks={page.pageBuilder} dynamicData={dynamicData} />

		</>
	)
}

export default Page
